import { render, staticRenderFns } from "./login-page.vue?vue&type=template&id=223e10e7"
import script from "./login-page.vue?vue&type=script&lang=js"
export * from "./login-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../Shield.UI.CommsManagerWebsite/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports